// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__gvrKs","table__headers":"styles_table__headers__cQDVI"};